import { ConfirmationDialog } from "@/components/shared/confirmation-dialog";

export interface ReferenceDeleteDialogProps {
    open: boolean;
    clientKey: string;
    name: string;
    occurrenceCount: number;
    isPending?: boolean;
    onConfirm: (clientKey: string) => void;
    onCancel: () => void;
}

const times = (count: number) => `${count} ${count === 1 ? "time" : "times"}`;

export function ReferenceDeleteDialog({
    open,
    clientKey,
    name,
    occurrenceCount,
    isPending = false,
    onConfirm,
    onCancel,
}: ReferenceDeleteDialogProps) {
    return (
        <ConfirmationDialog
            open={open}
            onOpenChange={(next) => {
                if (!next) onCancel();
            }}
            title="Remove reference?"
            description={
                <>
                    &quot;{name}&quot; is @-referenced {times(occurrenceCount)}.
                    Those mentions will read as invalid until you fix them.
                </>
            }
            onConfirm={() => onConfirm(clientKey)}
            confirmLabel="Remove"
            variant="destructive"
            isPending={isPending}
            closeOnConfirm={false}
        />
    );
}
